import Vue from 'vue'

const state = {
    badge_id: null,
    message_id: null,
    news_id: null
}

const actions = {
    SET_MESSAGE_ID(context, [message_id]) {
        context.commit('SAVE_MESSAGE_ID', [message_id])
    },

    SET_BADGE_ID(context, [badge_id]) {
        context.commit('SAVE_BADGE_ID', [badge_id])
    },

    SET_NEWS_ID(context, [news_id]) {
        context.commit('SAVE_NEWS_ID', [news_id])
    },
}

const mutations = {
    SAVE_MESSAGE_ID: (state, [message_id]) => {
        Vue.set(state, 'message_id', message_id)
    },

    SAVE_BADGE_ID: (state, [badge_id]) => {
        Vue.set(state, 'badge_id', badge_id)
    },

    SAVE_NEWS_ID: (state, [news_id]) => {
        Vue.set(state, 'news_id', news_id)
    },
}

const getters = {
    badge_id: state => {
        return state.badge_id
    },

    message_id: state => {
        return state.message_id
    },

    news_id: state => {
        return state.news_id
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}